// Red-yellow-green cell gradient shared by the Predictions and Simulator tables.

export const COLORS = {
  max: "#62BF7B", // Green
  mid: "#FDE883", // Yellow
  min: "#F9696D", // Red
  none: "#FFFFFF", // White
};

// Helper function to interpolate between two colors
export const interpolateColor = (color1: string, color2: string, factor: number) => {
  const result = color1.match(/\w\w/g)?.map((c, i) => {
    const c1 = parseInt(c, 16);
    const c2 = parseInt(color2.match(/\w\w/g)![i], 16);
    const value = Math.round(c1 + factor * (c2 - c1));
    return value.toString(16).padStart(2, '0');
  });
  return `#${result?.join('')}`;
};

// Helper function to determine cell color based on value and type
export const getCellColor = (value: number, type: 'position' | 'probability') => {
  if (type === 'position') {
    // For positions: 1 (green) to 40 (red)
    const normalizedValue = Math.min(Math.max(value, 1), 40);
    const factor = (normalizedValue - 1) / 39; // 39 is the range (40 - 1)

    if (factor <= 0.5) {
      // Interpolate between green and yellow for first half
      return interpolateColor(COLORS.max, COLORS.mid, factor * 2);
    } else {
      // Interpolate between yellow and red for second half
      return interpolateColor(COLORS.mid, COLORS.min, (factor - 0.5) * 2);
    }
  } else {
    // For probabilities: 0 (red) to 100 (green)
    const normalizedValue = Math.min(Math.max(value * 100, 0), 100);
    const factor = normalizedValue / 100;

    if (factor <= 0.5) {
      // Interpolate between red and yellow for first half
      return interpolateColor(COLORS.min, COLORS.mid, factor * 2);
    } else {
      // Interpolate between yellow and green for second half
      return interpolateColor(COLORS.mid, COLORS.max, (factor - 0.5) * 2);
    }
  }
};
